import React from "react";

const HomeGoogleCompliance = () => {
  return (
    <section
      id="about-twokey"
      className="bg-white py-20 px-4 md:px-8 lg:px-16 font-tahoma"
    >
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h5 className="text-sm md:text-base font-semibold text-[#5E5ADB] uppercase tracking-wider mb-4">
            ABOUT TWOKEY
          </h5>

          <h2 className="text-4xl md:text-5xl font-bold text-[#273720] mb-6">
            Secure Document Management & Collaboration
          </h2>

          <p className="max-w-3xl mx-auto text-lg text-gray-600 leading-relaxed">
            TwoKey is a secure document management and collaboration platform
            designed for businesses and teams.
          </p>
        </div>

        {/* Main Description */}
        <div className="bg-[#F8F8FF] rounded-3xl p-8 md:p-12 shadow-sm border border-[#E8E8FF]">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Left */}
            <div>
              <h3 className="text-2xl font-bold text-[#273720] mb-6">
                What users can do with TwoKey
              </h3>

              <ul className="space-y-4 text-gray-700">
                <li className="flex gap-3">
                  <span className="text-[#5E5ADB] font-bold">✓</span>
                  <span>
                    Upload, create and manage business documents, spreadsheets,
                    PDFs, images and other files.
                  </span>
                </li>

                <li className="flex gap-3">
                  <span className="text-[#5E5ADB] font-bold">✓</span>
                  <span>
                    Organize files using departments and role-based permissions.
                  </span>
                </li>

                <li className="flex gap-3">
                  <span className="text-[#5E5ADB] font-bold">✓</span>
                  <span>Collaborate with colleagues in shared workspaces.</span>
                </li>

                <li className="flex gap-3">
                  <span className="text-[#5E5ADB] font-bold">✓</span>
                  <span>
                    Secure files using password protection, file locking and
                    access controls.
                  </span>
                </li>

                <li className="flex gap-3">
                  <span className="text-[#5E5ADB] font-bold">✓</span>
                  <span>
                    Monitor activity through audit logs and tracking tools.
                  </span>
                </li>
              </ul>
            </div>

            {/* Right */}
            <div className="space-y-8">
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-[#E8E8FF]">
                <h3 className="text-xl font-bold text-[#273720] mb-3">
                  Google Drive Integration
                </h3>

                <p className="text-gray-700 leading-relaxed">
                  Users may optionally connect their Google Drive account to
                  import files into TwoKey and export files from TwoKey back to
                  Google Drive.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-[#E8E8FF]">
                <h3 className="text-xl font-bold text-[#273720] mb-3">
                  Gmail Integration
                </h3>

                <p className="text-gray-700 leading-relaxed">
                  Users may optionally connect their Gmail account to access,
                  read and manage Gmail messages directly from within the TwoKey
                  workspace.
                </p>
              </div>

              <div className="bg-[#5E5ADB] text-white rounded-2xl p-6">
                <h3 className="text-xl font-bold mb-3">
                  Google User Data Usage
                </h3>

                <p className="leading-relaxed text-white/95">
                  Google user data is only accessed to provide these
                  user-requested integrations. TwoKey does not sell Google user
                  data and does not use Google user data for advertising
                  purposes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeGoogleCompliance;
